/**
 * This interface mirrors the event object as described by ngx-bootstrap paginator API.
 */
export class PageInfo {
    page: number;
    itemsPerPage: number;

    constructor(page: number, itemsPerPage: number) {
        this.page = page;
        this.itemsPerPage = itemsPerPage;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/pagination/page-info.ts